import {
    FETCH_RECENTS_REQUEST,
    FETCH_RECENTS_SUCCESS,
    FETCH_RECENTS_FAILURE,
    ADD_RECENTS_REQUEST,
    ADD_RECENTS_SUCCESS,
    ADD_RECENTS_FAILURE,
    DELETE_RECENTS_REQUEST,
    DELETE_RECENTS_SUCCESS,
    DELETE_RECENTS_FAILURE,
    TOGGLE_RECENT_AS_FAVORITE,
    UPDATE_RECENTS_WITH_FAVORITES,
    REORDER_RECENTS
} from '../actions/actionsConstants';

const initialState = { products: [], isFetched: false };

export default function recents(state = initialState, action) {
    switch (action.type) {
        case UPDATE_RECENTS_WITH_FAVORITES: {
            const favoriteVariants = action.payload.map(product => product.variant_id);

            const updatedProducts = state.products.map(product => ({
                ...product,
                isFavorite: favoriteVariants.includes(product.variant_id)
            }));

            return { ...state, products: updatedProducts };
        }

        case TOGGLE_RECENT_AS_FAVORITE: {
            const toggledProducts = state.products.map((product) => {
                if (action.payload === product.variant_id) {
                    product.isFavorite = action.toggle;
                }

                return product;
            });

            return { ...state, products: toggledProducts };
        }

        case FETCH_RECENTS_REQUEST:
            return { ...state, products: [], isFetched: false };
        case FETCH_RECENTS_SUCCESS:
            return { ...state, products: action.payload, isFetched: true };
        case FETCH_RECENTS_FAILURE:
            return state;

        case REORDER_RECENTS: {
            // if product is already in recents -> move to the top of the list
            const reorderedProducts = state.products.reduce((acc, product) => {
                if (product.variant_id !== action.payload) {
                    // eslint-disable-next-line no-param-reassign
                    acc = [...acc, product];
                } else {
                    // eslint-disable-next-line no-param-reassign
                    acc = [product, ...acc];
                }

                return acc;
            }, []);
            return { ...state, products: reorderedProducts };
        }

        case ADD_RECENTS_REQUEST:
            return state;
        case ADD_RECENTS_SUCCESS:
            if (action.payload) {
                return { ...state, products: [action.payload, ...state.products] };
            }

            return state;
        case ADD_RECENTS_FAILURE:
            return state;
        case DELETE_RECENTS_REQUEST:
            return state;

        case DELETE_RECENTS_SUCCESS: {
            if (typeof action.payload === 'undefined') {
                return { ...state, products: [] };
            }

            let products = [];
            const variantIds = typeof action.payload === 'number' ? [action.payload] : action.payload;

            if (state.products.length > 0) {
                products = state.products.filter((product) => {
                    const variantId = product.variant_id ?? product.variants[0].id;
                    return !variantIds.includes(variantId);
                });
            }

            return { ...state, products };
        }

        case DELETE_RECENTS_FAILURE:
            return state;
        default:
            return state;
    }
}
